export const DIMENSIONS = {
  values: {
    medium: {
      collage: {
        fabric: {},
        'mixed-media-1': {},
        'paper-1': {},
        photo: {},
      },
      drawings: {
        chalk: {},
        charcoal: {},
        crayon: {},
        ink: {},
        pastel: {},
        pencil: {},
      },
      installation: {},
      paintings: {
        acrylic: {},
        airbrush: {},
        encaustic: {},
        'fabric-1': {},
        gouache: {},
        'ink-1': {},
        'mixed-media-2': {},
        oil: {},
        tempera: {},
        watercolour: {},
      },
      photography: {
        'black-white': {},
        colour: {},
        'digital-1': {},
        'mixed-media': {},
        pinhole: {},
      },
      prints: {
        digital: {},
        etching: {},
        lino: {},
        lithograph: {},
        'mixed-media-3': {},
        mono: {},
        screenprint: {},
        transfer: {},
        woodcut: {},
      },
      sculpture: {
        bronze: {},
        ceramic: {},
        clay: {},
        enamel: {},
        glass: {},
        kinetic: {},
        marble: {},
        metal: {},
        paper: {},
        plastic: {},
        resin: {},
        stone: {},
        wood: {},
      },
      digital: {
        vector: {},
      },
    },
    style: {
      abstract: {},
      'abstract-expressionism': {},
      'abstract-marble': {},
      'art-deco': {},
      cartoon: {},
      conceptual: {},
      cubism: {},
      'colour-field': {},
      dada: {},
      expressionistic: {},
      figurative: {},
      geometric: {},
      'geometric-abstract': {},
      graphic: {},
      illustrative: {},
      impressionistic: {},
      minimalistic: {},
      mosaic: {},
      photorealism: {},
      'pop-art': {},
      realistic: {},
      stencil: {},
      'street-art': {},
      surrealist: {},
    },
    subject: {
      animals: {
        bird: {},
        cat: {},
        cow: {},
        dog: {},
        fish: {},
        horse: {},
      },
      architecture: {},
      botanical: {
        flower: {},
        leaves: {},
        tree: {},
      },
      celebrities: {},
      cityscapes: {
        'hong-kong': {},
        'london-1': {},
        'new-york-1': {},
        paris: {},
        singapore: {},
      },
      documentary: {},
      fantasy: {},
      fashion: {},
      food: {},
      landscapes: {
        beach: {},
        rural: {},
        sky: {},
      },
      maps: {
        london: {},
        'new-york': {},
      },
      music: {},
      nature: {},
      nudes: {},
      politics: {},
      portraits: {
        female: {},
        male: {},
      },
      'science-technology': {},
      seascapes: {},
      spirituality: {
        religion: {},
      },
      sports: {
        athletics: {},
        cycling: {},
        football: {},
      },
      'still-life': {
        'flower-1': {},
        food: {},
      },
      'transport-auto': {
        airplane: {},
        bike: {},
        car: {},
        ship: {},
        train: {},
        yacht: {},
      },
      typography: {},
      underwater: {},
      urban: {},
      wildlife: {},
    },
    orientation: {
      S: {},
      P: {},
      L: {},
    },
    color: {
      colourful: {},
      'black-white': {},
      white: {},
      grey: {},
      black: {},
      'maroon-neutral': {},
      orange: {},
      yellow: {},
      green: {},
      blue: {},
      purple: {},
      pink: {},
      red: {},
    },
    price: {
      0: {},
      100: {},
      200: {},
      300: {},
      500: {},
      1000: {},
      2000: {},
      5000: {},
      10000: {},
    },
    size: {
      S: {},
      M: {},
      L: {},
      XL: {},
      XXL: {},
    },
    practice: {
      collagists: {},
      digital: {},
      draftspersons: {},
      installation: {},
      painters: {},
      photographers: {},
      printmakers: {},
      sculptors: {},
    },
    initials: {
      A: {},
      B: {},
      C: {},
      D: {},
      E: {},
      F: {},
      G: {},
      H: {},
      I: {},
      J: {},
      K: {},
      L: {},
      M: {},
      N: {},
      O: {},
      P: {},
      Q: {},
      R: {},
      S: {},
      T: {},
      U: {},
      V: {},
      W: {},
      X: {},
      Y: {},
      Z: {},
    },
    countries: {
      AD: {},
      AE: {},
      AF: {},
      AG: {},
      AI: {},
      AL: {},
      AM: {},
      AN: {},
      AO: {},
      AQ: {},
      AR: {},
      AS: {},
      AT: {},
      AU: {},
      AW: {},
      AX: {},
      AZ: {},
      BA: {},
      BB: {},
      BD: {},
      BE: {},
      BF: {},
      BG: {},
      BH: {},
      BI: {},
      BJ: {},
      BM: {},
      BN: {},
      BO: {},
      BR: {},
      BS: {},
      BT: {},
      BV: {},
      BW: {},
      BY: {},
      BZ: {},
      CA: {},
      CC: {},
      CD: {},
      CF: {},
      CG: {},
      CH: {},
      CI: {},
      CK: {},
      CL: {},
      CM: {},
      CN: {},
      CO: {},
      CR: {},
      CU: {},
      CV: {},
      CX: {},
      CY: {},
      CZ: {},
      DE: {},
      DJ: {},
      DK: {},
      DM: {},
      DO: {},
      DZ: {},
      EC: {},
      EE: {},
      EG: {},
      EH: {},
      ER: {},
      ES: {},
      ET: {},
      FI: {},
      FJ: {},
      FK: {},
      FM: {},
      FO: {},
      FR: {},
      GA: {},
      GB: {},
      GD: {},
      GE: {},
      GF: {},
      GG: {},
      GH: {},
      GI: {},
      GL: {},
      GM: {},
      GN: {},
      GP: {},
      GQ: {},
      GR: {},
      GS: {},
      GT: {},
      GU: {},
      GW: {},
      GY: {},
      HK: {},
      HM: {},
      HN: {},
      HR: {},
      HT: {},
      HU: {},
      ID: {},
      IE: {},
      IL: {},
      IM: {},
      IN: {},
      IO: {},
      IQ: {},
      IR: {},
      IS: {},
      IT: {},
      JE: {},
      JM: {},
      JO: {},
      JP: {},
      KE: {},
      KG: {},
      KH: {},
      KI: {},
      KM: {},
      KN: {},
      KP: {},
      KR: {},
      KW: {},
      KY: {},
      KZ: {},
      LA: {},
      LB: {},
      LC: {},
      LI: {},
      LK: {},
      LR: {},
      LS: {},
      LT: {},
      LU: {},
      LV: {},
      LY: {},
      MA: {},
      MC: {},
      MD: {},
      ME: {},
      MF: {},
      MG: {},
      MH: {},
      MK: {},
      ML: {},
      MM: {},
      MN: {},
      MO: {},
      MP: {},
      MQ: {},
      MR: {},
      MS: {},
      MT: {},
      MU: {},
      MV: {},
      MW: {},
      MX: {},
      MY: {},
      MZ: {},
      NA: {},
      NC: {},
      NE: {},
      NF: {},
      NG: {},
      NI: {},
      NL: {},
      NO: {},
      NP: {},
      NR: {},
      NU: {},
      NZ: {},
      O1: {},
      OM: {},
      PA: {},
      PE: {},
      PF: {},
      PG: {},
      PH: {},
      PK: {},
      PL: {},
      PM: {},
      PN: {},
      PR: {},
      PS: {},
      PT: {},
      PW: {},
      PY: {},
      QA: {},
      RE: {},
      RO: {},
      RS: {},
      RU: {},
      RW: {},
      SA: {},
      SB: {},
      SC: {},
      SD: {},
      SE: {},
      SG: {},
      SH: {},
      SI: {},
      SJ: {},
      SK: {},
      SL: {},
      SM: {},
      SN: {},
      SO: {},
      SR: {},
      ST: {},
      SV: {},
      SY: {},
      SZ: {},
      TC: {},
      TD: {},
      TF: {},
      TG: {},
      TH: {},
      TJ: {},
      TK: {},
      TL: {},
      TM: {},
      TN: {},
      TO: {},
      TR: {},
      TT: {},
      TV: {},
      TW: {},
      TZ: {},
      UA: {},
      UG: {},
      UM: {},
      US: {},
      UY: {},
      UZ: {},
      VA: {},
      VC: {},
      VE: {},
      VG: {},
      VI: {},
      VN: {},
      VU: {},
      WF: {},
      WS: {},
      YE: {},
      YT: {},
      ZA: {},
      ZM: {},
      ZW: {},
    },
    gender: {
      F: {},
      M: {},
    },
    stage: {
      new: {},
      emerging: {},
      established: {},
    },
    region: {
      african: {},
      'north-american': {},
      'latin-american': {},
      caribbean: {},
      european: {},
      scandinavian: {},
      'easter-european': {},
      asian: {},
      'south-asian': {},
      'middle-eastern': {},
      oceanian: {},
    },
  },
  mappers: {
    medium: [
      {
        from: 'art',
        to: 'artist',
        values: {
          collage: 'collagists',
          digital: 'digital',
          drawings: 'draftspersons',
          installation: 'installation',
          paintings: 'painters',
          photography: 'photographers',
          prints: 'printmakers',
          sculpture: 'sculptors',
        },
      },
    ],
    style: [
      {
        from: 'art',
        to: 'artist',
        values: {
          abstract: 'abstract',
          'abstract-expressionism': 'abstract-expressionism',
          'abstract-marble': 'abstract-marble',
          'art-deco': 'art-deco',
          cartoon: 'cartoon',
          conceptual: 'conceptual',
          cubism: 'cubism',
          'colour-field': 'colour-field',
          dada: 'dada',
          expressionistic: 'expressionistic',
          figurative: 'figurative',
          geometric: 'geometric',
          'geometric-abstract': 'geometric-abstract',
          graphic: 'graphic',
          illustrative: 'illustrative',
          impressionistic: 'impressionistic',
          minimalistic: 'minimalistic',
          mosaic: 'mosaic',
          photorealism: 'photorealism',
          'pop-art': 'pop-art',
          realistic: 'realistic',
          stencil: 'stencil',
          'street-art': 'street-art',
          surrealist: 'surrealist',
        },
      },
    ],
  },
  domains: {
    art: {
      medium: {
        type: 'list',
        position: 1,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'multiple',
        canonical: 'single',
        childDimension: {
          subMedium: {
            type: 'list',
            position: 2,
            inPath: true,
            multiValue: true,
            multiValueSeparator: ',',
            noindex: 'multiple',
            canonical: 'single',
          },
        },
        values: 'medium',
      },
      style: {
        type: 'list',
        position: 3,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'multiple',
        canonical: 'single',
        childDimension: {},
        values: 'style',
      },
      subject: {
        type: 'list',
        position: 4,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'multiple',
        canonical: 'single',
        childDimension: {
          subSubject: {
            type: 'list',
            position: 5,
            inPath: true,
            multiValue: true,
            multiValueSeparator: ',',
            noindex: 'multiple',
            canonical: 'single',
          },
        },
        values: 'subject',
      },
      stage: {
        type: 'list',
        inPath: false,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'all',
        canonical: 'none',
        childDimension: {},
        values: 'stage',
      },
      orientation: {
        type: 'list',
        inPath: false,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: 'values',
        allowClearAll: false,
        noindex: 'all',
        canonical: 'none',
        values: 'orientation',
      },
      color: {
        type: 'list',
        inPath: false,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: 'values',
        allowClearAll: true,
        noindex: 'all',
        canonical: 'none',
        values: 'color',
      },
      price: {
        type: 'range',
        inPath: false,
        multiValue: false,
        rangeSeparator: '-',
        rangeType: 'continuous',
        rangeUpperBound: 'UP',
        sortBy: 'values',
        allowClearAll: false,
        translate: false,
        noindex: 'all',
        canonical: 'none',
        value: 'price',
        values: {
          type: '__custom',
          transform: 'range',
          config: [
            { from: 0, to: 5000, step: 100 },
            { from: 5000, to: 10000, step: 500 },
            { from: 10000, to: 20000, step: 1000 },
          ],
        },
      },
      size: {
        type: 'range',
        inPath: false,
        multiValue: false,
        rangeSeparator: '-',
        rangeType: 'discreet',
        sortBy: 'values',
        allowClearAll: false,
        noindex: 'all',
        canonical: 'none',
        translationValues: { S: 45, M: 65, L: 95, XL: 150, XXL: 150 },
        translationModifier: {
          name: 'convertUnitLength',
        },
        values: 'size',
      },
      width: {
        type: 'range',
        inPath: false,
        multiValue: false,
        rangeSeparator: '-',
        rangeType: 'continuous',
        rangeUpperBound: 'UP',
        sortBy: 'values',
        allowClearAll: false,
        translate: false,
        noindex: 'all',
        canonical: 'none',
        values: {
          type: '__custom',
          transform: 'range',
          conditional: true,
          config: [
            {
              condition: { property: 'unitLength', value: 'centimeter' },
              steps: [
                { from: 0, to: 500, step: 50 },
                { from: 500, to: 3000, step: 100 },
              ],
            },
            {
              condition: { property: 'unitLength', value: 'inch' },
              steps: [
                { from: 0, to: 300, step: 50 },
                { from: 300, to: 1200, step: 100 },
              ],
              modifier: {
                name: 'convertUnitLength',
                args: { from: 'inch', to: 'centimeter' },
              },
            },
          ],
        },
      },
      height: {
        type: 'range',
        inPath: false,
        multiValue: false,
        rangeSeparator: '-',
        rangeType: 'continuous',
        rangeUpperBound: 'UP',
        sortBy: 'values',
        allowClearAll: false,
        translate: false,
        noindex: 'all',
        canonical: 'none',
        values: {
          type: '__custom',
          transform: 'range',
          conditional: true,
          config: [
            {
              condition: { property: 'unitLength', value: 'centimeter' },
              steps: [
                { from: 0, to: 500, step: 50 },
                { from: 500, to: 3000, step: 100 },
              ],
            },
            {
              condition: { property: 'unitLength', value: 'inch' },
              steps: [
                { from: 0, to: 300, step: 50 },
                { from: 300, to: 1200, step: 100 },
              ],
              modifier: {
                name: 'convertUnitLength',
                args: { from: 'inch', to: 'centimeter' },
              },
            },
          ],
        },
      },
      ships: {
        type: 'list',
        inPath: false,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        translationPrefix: 'countries.',
        noindex: 'all',
        canonical: 'none',
        childDimension: {},
        values: 'countries',
      },
    },
    artist: {
      medium: {
        type: 'list',
        position: 1,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'multiple',
        canonical: 'single',
        childDimension: {},
        values: 'practice',
      },
      style: {
        type: 'list',
        position: 2,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'multiple',
        canonical: 'single',
        childDimension: {},
        values: 'style',
      },
      initial: {
        type: 'list',
        inPath: false,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        translate: false,
        noindex: 'all',
        canonical: 'none',
        childDimension: {},
        values: 'initials',
      },
      gender: {
        type: 'list',
        position: 5,
        inPath: true,
        multiValue: false,
        sortBy: 'values',
        allowClearAll: false,
        noindex: 'multiple',
        canonical: 'single',
        values: 'gender',
      },
      ships: {
        type: 'list',
        inPath: false,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        translationPrefix: 'countries.',
        noindex: 'all',
        canonical: 'none',
        childDimension: {},
        values: 'countries',
      },
      stage: {
        type: 'list',
        inPath: false,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'all',
        canonical: 'none',
        childDimension: {},
        values: 'stage',
      },
      region: {
        type: 'list',
        position: 3,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'multiple',
        canonical: 'single',
        childDimension: {},
        values: 'region',
      },
      born: {
        type: 'list',
        position: 4,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        translationPrefix: 'nationalities.',
        noindex: 'multiple',
        canonical: 'single',
        childDimension: {},
        values: 'countries',
      },
    },
    collection: {
      medium: {
        type: 'list',
        position: 1,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'all',
        canonical: 'none',
        childDimension: {},
        values: 'medium',
      },
      style: {
        type: 'list',
        position: 2,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'all',
        canonical: 'none',
        childDimension: {},
        values: 'style',
      },
      subject: {
        type: 'list',
        position: 3,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'all',
        canonical: 'none',
        childDimension: {},
        values: 'subject',
      },
    },
    collectionArt: {
      orientation: {
        type: 'list',
        inPath: false,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: 'values',
        allowClearAll: false,
        noindex: 'all',
        canonical: 'none',
        values: 'orientation',
      },
      price: {
        type: 'range',
        inPath: false,
        multiValue: false,
        rangeSeparator: '-',
        rangeType: 'continuous',
        rangeUpperBound: 'UP',
        sortBy: 'values',
        allowClearAll: false,
        noindex: 'all',
        canonical: 'none',
        values: 'price',
      },
      size: {
        type: 'range',
        inPath: false,
        multiValue: false,
        rangeSeparator: '-',
        rangeType: 'discreet',
        sortBy: 'values',
        allowClearAll: false,
        noindex: 'all',
        canonical: 'none',
        values: 'size',
      },
    },
    favoritesArt: {
      medium: {
        type: 'list',
        position: 1,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'multiple',
        canonical: 'single',
        childDimension: {
          subMedium: {
            type: 'list',
            position: 2,
            inPath: true,
            multiValue: true,
            multiValueSeparator: ',',
            noindex: 'multiple',
            canonical: 'single',
          },
        },
        values: 'medium',
      },
      subject: {
        type: 'list',
        position: 4,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'multiple',
        canonical: 'single',
        childDimension: {
          subSubject: {
            type: 'list',
            position: 5,
            inPath: true,
            multiValue: true,
            multiValueSeparator: ',',
            noindex: 'multiple',
            canonical: 'single',
          },
        },
        values: 'subject',
      },
      price: {
        type: 'range',
        inPath: false,
        multiValue: false,
        rangeSeparator: '-',
        rangeType: 'continuous',
        rangeUpperBound: 'UP',
        sortBy: 'values',
        allowClearAll: false,
        noindex: 'all',
        canonical: 'none',
        values: 'price',
      },
      size: {
        type: 'range',
        inPath: false,
        multiValue: false,
        rangeSeparator: '-',
        rangeType: 'discreet',
        sortBy: 'values',
        allowClearAll: false,
        noindex: 'all',
        canonical: 'none',
        values: 'size',
      },
    },
    favoritesArtist: {
      medium: {
        type: 'list',
        position: 1,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        noindex: 'multiple',
        canonical: 'single',
        childDimension: {},
        values: 'practice',
      },
      initial: {
        type: 'list',
        inPath: false,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        translate: false,
        noindex: 'all',
        canonical: 'none',
        childDimension: {},
        values: 'initials',
      },
      born: {
        type: 'list',
        position: 4,
        inPath: true,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        translationPrefix: 'nationalities.',
        noindex: 'multiple',
        canonical: 'single',
        childDimension: {},
        values: 'countries',
      },
      ships: {
        type: 'list',
        inPath: false,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: null,
        allowClearAll: true,
        translationPrefix: 'countries.',
        noindex: 'all',
        canonical: 'none',
        childDimension: {},
        values: 'countries',
      },
    },
    artistArt: {
      orientation: {
        type: 'list',
        inPath: false,
        multiValue: true,
        multiValueSeparator: ',',
        sortBy: 'values',
        allowClearAll: false,
        noindex: 'all',
        canonical: 'none',
        values: 'orientation',
      },
      price: {
        type: 'range',
        inPath: false,
        multiValue: false,
        rangeSeparator: '-',
        rangeType: 'continuous',
        rangeUpperBound: 'UP',
        sortBy: 'values',
        allowClearAll: false,
        noindex: 'all',
        canonical: 'none',
        values: 'price',
      },
      size: {
        type: 'range',
        inPath: false,
        multiValue: false,
        rangeSeparator: '-',
        rangeType: 'discreet',
        sortBy: 'values',
        allowClearAll: false,
        noindex: 'all',
        canonical: 'none',
        values: 'size',
      },
    },
  },
};
